import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class SpinnerService {
	private activeRequestsCount = 0;
	public visibility: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
		false
	);

	show() {
		this.activeRequestsCount++;
		this.visibility.next(true);
	}

	hide() {
		this.activeRequestsCount--;
		if (this.activeRequestsCount <= 0) {
			this.activeRequestsCount = 0;
			this.visibility.next(false);
		}
	}
}
